<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    // this.showToastMask()
  },
  methods: {

  }
}
</script>

<style lang="stylus">
@import "assets/css/common.scss";
body,html
  background-color #f2f2f2
  height: 100%
  padding: 0
  margin: 0
.clearfix:after
  content: "020"
  display: block
  height: 0
  clear: both
  visibility: hidden
.clearfix
  zoom: 1;

#app
  background-color: white
  height: 100%
  box-sizing: border-box
  position: relative
  max-width: 480px
  margin: 0 auto
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC","Helvetica Neue",STHeiti,"Microsoft Yahei",Tahoma,Simsun,sans-serif
</style>



// WEBPACK FOOTER //
// src/App.vue